"use strict";

class DeveloperCustomSettingsController {

    constructor($parse, $timeout, SSHttpService, SSUtilService, SSAlertService, SSUserService, OTPService, SSConfirmationService, SSConfigService, SSEmailNotificationScheduleService) {
        const self = this;

        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSConfigService = SSConfigService;
        self.ScheduleService = SSEmailNotificationScheduleService;

        self.data = SHOWSUITE.data;

        self.DEVELOPER_SETTINGS_PAYMENT_TRACKING_NUMBER = SHOWSUITE.DEVELOPER_SETTINGS_PAYMENT_TRACKING_NUMBER;
        self.DEVELOPER_SETTINGS_INSTRUMENT_TRACKING_NUMBER = SHOWSUITE.DEVELOPER_SETTINGS_INSTRUMENT_TRACKING_NUMBER;
        self.DEVELOPER_SETTINGS_PAYMENT_DAILY_FREEZING_SLOT = SHOWSUITE.DEVELOPER_SETTINGS_PAYMENT_DAILY_FREEZING_SLOT;
        self.DEVELOPER_SETTINGS_PAYMENT_MONTHLY_FREEZING_SLOT = SHOWSUITE.DEVELOPER_SETTINGS_PAYMENT_MONTHLY_FREEZING_SLOT;
        self.DEVELOPER_SETTINGS_DIFFERENT_OTP_FOR_COMMERCIAL_UNITS = SHOWSUITE.DEVELOPER_SETTINGS_DIFFERENT_OTP_FOR_COMMERCIAL_UNITS;
        self.DEVELOPER_SETTINGS_SESSION_TIMEOUT = SHOWSUITE.DEVELOPER_SETTINGS_SESSION_TIMEOUT;
        self.DEVELOPER_SETTINGS_PASSWORD_VALIDATION = SHOWSUITE.DEVELOPER_SETTINGS_PASSWORD_VALIDATION;
        self.DEVELOPER_SETTINGS_REFUND_PAYMENT_TRACKING_NUMBER = SHOWSUITE.DEVELOPER_SETTINGS_REFUND_PAYMENT_TRACKING_NUMBER;
        self.DEVELOPER_SETTINGS_PASSWORD_BASED_LOGIN = SHOWSUITE.DEVELOPER_SETTINGS_PASSWORD_BASED_LOGIN;

        self.EMAIL_NOTIFICATION_SPA_DELIVERY_EXPIRY = SHOWSUITE.EMAIL_NOTIFICATION_SPA_DELIVERY_EXPIRY;
        self.EMAIL_NOTIFICATION_SPA_EXPIRY = SHOWSUITE.EMAIL_NOTIFICATION_SPA_EXPIRY;
        self.EMAIL_NOTIFICATION_OPTION_EXERCISED_SUMMARY = SHOWSUITE.EMAIL_NOTIFICATION_OPTION_EXERCISED_SUMMARY;
        self.EMAIL_NOTIFICATION_OPTION_EXERCISED = SHOWSUITE.EMAIL_NOTIFICATION_OPTION_EXERCISED;
        self.EMAIL_NOTIFICATION_OUTSTANDING_PROGRESSIVE_PAYMENTS = SHOWSUITE.EMAIL_NOTIFICATION_OUTSTANDING_PROGRESSIVE_PAYMENTS;
        
        self.EMAIL_NOTIFICATION_UPDATE_BUYER = SHOWSUITE.EMAIL_NOTIFICATION_UPDATE_BUYER;
        self.EMAIL_NOTIFICATION_UPDATE_BUYER_LAWYER = SHOWSUITE.EMAIL_NOTIFICATION_UPDATE_BUYER_LAWYER;
        self.EMAIL_NOTIFICATION_NEW_PAYMENT_RECEIVED = SHOWSUITE.EMAIL_NOTIFICATION_NEW_PAYMENT_RECEIVED;
        self.EMAIL_NOTIFICATION_PAYMENT_CLAUSES = SHOWSUITE.EMAIL_NOTIFICATION_PAYMENT_CLAUSES;
        self.EMAIL_NOTIFICATION_NEW_PROGRESSIVE_PAYMENTS = SHOWSUITE.EMAIL_NOTIFICATION_NEW_PROGRESSIVE_PAYMENTS;
        self.EMAIL_NOTIFICATION_NOTICE_SERVED_BY_LAWYER = SHOWSUITE.EMAIL_NOTIFICATION_NOTICE_SERVED_BY_LAWYER;
        self.EMAIL_NOTIFICATION_UNIT_RESERVED = SHOWSUITE.EMAIL_NOTIFICATION_UNIT_RESERVED;
        self.EMAIL_NOTIFICATION_UNIT_RESERVED_OVERTIME = SHOWSUITE.EMAIL_NOTIFICATION_UNIT_RESERVED_OVERTIME;
        self.EMAIL_NOTIFICATION_PASSPORT_EXPIRY = SHOWSUITE.EMAIL_NOTIFICATION_PASSPORT_EXPIRY;
        self.EMAIL_NOTIFICATION_AGENCY_COMMISSION_CLAIMABLE = SHOWSUITE.EMAIL_NOTIFICATION_AGENCY_COMMISSION_CLAIMABLE;
        self.EMAIL_NOTIFICATION_LAWFIRM_SALE_APPLICATIONS = SHOWSUITE.EMAIL_NOTIFICATION_LAWFIRM_SALE_APPLICATIONS;

        self.FREQUENCY_DAILY = SHOWSUITE.FREQUENCY_DAILY;
        self.FREQUENCY_WEEKLY = SHOWSUITE.FREQUENCY_WEEKLY;
        self.FREQUENCY_MONTHLY = SHOWSUITE.FREQUENCY_MONTHLY;
        self.FREQUENCY_FORTNIGHTLY = SHOWSUITE.FREQUENCY_FORTNIGHTLY;

        self.notifications = null;
        self.properties = null;

        self.const_dict_notifications = [];
        self.const_dict_frequencies = [];

        // WEB-4489: agencies (with the developer projects each is assigned to) for report code 15
        self.commissionAgencies = null;
        self.commissionAgenciesLoading = false;

        // WEB-4823: report code 16 is offered only to developers with report R111 (set from the list reply)
        self.lawFirmSaleApplicationsAvailable = false;
        // WEB-4823: law firms (with the developer projects each is assigned to) for report code 16
        self.saleApplicationsLawFirms = null;
        self.saleApplicationsLawFirmsLoading = false;

        self.sessionTimeoutEditMode = false;
        self.passwordComplexityEditMode = false;
        self.passwordBasedLoginEditMode = false;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()
            && self.SSUserService.hasPermission('DMS_DEVELOPER_SETTINGS_VIEW')
        ) {
            self.init();
            self.has_access = true;
        }

        // WEB-4383: the hardcoded FATF default list that used to sit here is gone.
        // Its only reader was the commented-out body of onEnableDisableFatfBlacklist()
        // below, and the live FATF screen (FATFBlacklistCountriesController) now seeds
        // from the server's canonical list. See config/country_lists.php on the API.
        self.selectedBlackListCountires = [];
    }

    init() {
        const self = this;

        self.invoice_no_settings = {};
        self.receipt_no_settings = {};

        self.refund_invoice_no_settings = {};

        self.password_based_login_settings = {
            value: {
                disabled: true
            }
        };

        self.developer_users = [];

        self.commission_approval_levels = [];

        self.sale_review_settings = {
            developer: {
                mandatory_documents_click: 0
            }
        }

        self.countries = self.SSConfigService.getCountries();
        if(self.countries && self.countries.length){ // Convert Country name to urf-8 string
            self.countries = self.countries.map(c => {
                c.name = self.SSUtilService.convertUnicodeToUtf8String(c.name);
                return c;
            })
        }

        self.non_blacklisted_countries = self.SSConfigService.getCountries();
        self.$timeout(function () {
            $("select.eoi-select").niceSelect();
        });

        // Methods to prepare dictionaries against constants
        self.prepareNotificationsDictionary();
        self.prepareFrequencyDictionary();

        // Methods to get required data
        self.getDeveloperUsers();
        self.getDeveloperProperties();
        self.getDeveloperSettings();
        self.getEmailNotifications();

        self.days = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];

    }

    getDeveloperUsers() {
        const self = this;

        let current_user = self.SSUserService.getUser();
        current_user.name = self.getUserFullName(current_user);
        self.developer_users.push(current_user);

        let url = 'sec/developer/users';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.users){
                $.each(response.data.users, function(index, user){
                    user.name = self.getUserFullName(user);
                    self.developer_users.push(user);
                });
            }
        });
    }

    getUserFullName(user){
        const self = this;

        let name = "";
        if(user){
            name = (user.first_name? user.first_name : "") + " " + (user.last_name? user.last_name : "");
        }

        return name;
    }

    // ----------- GENERAL SETTINGS SECTION  -------

    getDeveloperSettings() {
        const self = this;

        let url = 'sec/developer/settings';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.developer_settings){

                self.invoice_no_settings = self.getSetting(response.data.developer_settings, self.DEVELOPER_SETTINGS_PAYMENT_TRACKING_NUMBER);
                self.receipt_no_settings = self.getSetting(response.data.developer_settings, self.DEVELOPER_SETTINGS_INSTRUMENT_TRACKING_NUMBER);
                self.refund_invoice_no_settings = self.getSetting(response.data.developer_settings, self.DEVELOPER_SETTINGS_REFUND_PAYMENT_TRACKING_NUMBER);
                self.payment_daily_freezing_slot_settings = self.getSetting(response.data.developer_settings, self.DEVELOPER_SETTINGS_PAYMENT_DAILY_FREEZING_SLOT);
                self.payment_monthly_freezing_slot_settings = self.getSetting(response.data.developer_settings, self.DEVELOPER_SETTINGS_PAYMENT_MONTHLY_FREEZING_SLOT);
                self.session_timeout = self.getSetting(response.data.developer_settings, self.DEVELOPER_SETTINGS_SESSION_TIMEOUT);
                self.otp_for_commercial_units_settings = self.getSetting(response.data.developer_settings, self.DEVELOPER_SETTINGS_DIFFERENT_OTP_FOR_COMMERCIAL_UNITS);
                self.password_validation = self.getSetting(response.data.developer_settings, self.DEVELOPER_SETTINGS_PASSWORD_VALIDATION);
                self.password_based_login_settings = self.getSetting(response.data.developer_settings, self.DEVELOPER_SETTINGS_PASSWORD_BASED_LOGIN);
                if (!self.password_based_login_settings) {
                    self.password_based_login_settings = {
                        name: self.DEVELOPER_SETTINGS_PASSWORD_BASED_LOGIN,
                        value: {disabled: false}
                    };
                }
                
                self.commission_settings = self.getSetting(response.data.developer_settings, 'commission_report_approval');
                // Prepare commission levels
                if(self.commission_settings && self.commission_settings.value){
                    self.commission_approval_levels = self.commission_settings.value.levels;
                }
                else{
                    // Set default empty level
                    self.commission_approval_levels.push({level: 0, user_ids: ""});
                }

                self.commission_approval_levels_master = angular.copy(self.commission_approval_levels);

                if(self.payment_daily_freezing_slot_settings) {

                    let utcStartTime = moment.utc(self.payment_daily_freezing_slot_settings.value.start_time, 'HH::mm');
                    let localStartTime = moment(utcStartTime).local().format('HH:mm');
                    self.payment_daily_freezing_slot_settings.value.start_time = localStartTime;

                    self.calculateEndTimeFromDuration(self.payment_daily_freezing_slot_settings);
                }
                if(self.payment_monthly_freezing_slot_settings){
                    let utcTime = moment.utc(self.payment_monthly_freezing_slot_settings.value.start_time, 'HH::mm');
                    let localTime = moment(utcTime).local().format('HH:mm');
                    self.payment_monthly_freezing_slot_settings.value.start_time = localTime;
                }

                if(!self.session_timeout){
                    self.session_timeout = {
                        name: self.DEVELOPER_SETTINGS_SESSION_TIMEOUT,
                        value: {enable: false, duration: 0}
                    };
                }

                // Get Visitor Appointment Settings
                self.appointment_settings = self.getSetting(response.data.developer_settings, 'visitor_appointment_settings');

                // Get FATF Blacklist Countries Settings
                self.fatf_blacklist_countries_settings = self.getSetting(response.data.developer_settings, 'fatf_blacklist_countries');
                if(self.fatf_blacklist_countries_settings
                        && self.fatf_blacklist_countries_settings.value
                        && self.fatf_blacklist_countries_settings.value.length){
                    self.fatf_blacklist_countries = self.fatf_blacklist_countries_settings.value;
                    self.haveBlacklistCountries = true;
                    // If blacklisted countries exist, update non-blacklisted countries list
                    self.non_blacklisted_countries = self.countries
                        .filter(c => self.fatf_blacklist_countries_settings.value.indexOf(c.country_code) === -1)
                    self.$timeout(function () {
                        $("select.eoi-select").niceSelect('update');
                    });
                }

                /** WEB-3055 DMS - Review New Sale - Disable action buttons till all documents are viewed **/
                self.sale_review_settings_response = self.getSetting(response.data.developer_settings, 'sale_review_settings');
                if(self.sale_review_settings_response && self.sale_review_settings_response.value){
                    self.sale_review_settings = self.sale_review_settings_response.value;
                }
            }
        });
    }

    calculateEndTimeFromDuration(params)
    {
        const self = this;
        // console.log("payment_daily_freezing_slot_settings" + JSON.stringify(params));


        // self.settingsParams = {};
        // self.settingsParams.value.is_enable = payment_daily_freezing_slot_settings.value.is_enable;
        let startTime = params.value.start_time;
        let durationMinutes = params.value.duration_minutes;


        if(durationMinutes) {
            self.payment_daily_freezing_slot_settings.value.end_time = moment(startTime, 'HH:mm').add(durationMinutes, 'minutes').format('HH:mm');
            // console.log("End Time: " + moment.utc(startTime,'hh:mm').add(durationMinutes,'minutes').format('hh:mm'));
        }

    }

    calculateDurationFromEndTime(params)
    {
        const self = this;

        let startTime = params.value.start_time;
        let endTime = params.value.end_time;

        if(!self.payment_daily_freezing_slot_settings.value.is_enable)
        {
            params.value = {
                "is_enable" : false,
            };

            return params;
        }

        endTime = moment(endTime,'HH:mm');

        let durationMinutes = endTime.diff(moment(startTime,'HH:mm'), 'minutes');
        // console.log("Difference in minutes: " + durationMinutes);

        params.value = {
            "is_enable" : self.payment_daily_freezing_slot_settings.value.is_enable,
            "start_time" : startTime,
            "duration_minutes" : durationMinutes,
        };

        return params;
        // let durationMinutes = payment_daily_freezing_slot_settings.value.duration_minutes;


    }

    getSetting(settings, setting_name){
        const self = this;

        if(!(settings || setting_name)){
            return null;
        }

        let setting = {};

        try{
            setting = settings.find(x => x.name == setting_name);

            if(setting && setting.value){
                if(typeof setting.value == "string"){
                    setting.value = JSON.parse(setting.value);
                }
                else{
                    setting.value = setting.value;
                }
            }
        }
        catch(ex){
            console.log(ex);
        }

        return setting;
    }

    editInvoiceNo(editMode){
        const self = this;

        self.settingsParams = {};
        self.settingsError = {};

        if (editMode) {

            self.settingsParams = angular.copy(self.invoice_no_settings );
        }

        self.receiptNoEditMode = false;
        self.refundInvoiceNoEditMode = false;
        self.invoiceNoEditMode = editMode;
    }

    editReceiptNo(editMode){
        const self = this;

        self.settingsParams = {};
        self.settingsError = {};

        if (editMode) {

            self.settingsParams = angular.copy(self.receipt_no_settings );
        }

        self.invoiceNoEditMode = false;
        self.refundInvoiceNoEditMode = false;
        self.receiptNoEditMode = editMode;
    }

    editRefundInvoiceNo(editMode){
        const self = this;

        self.settingsParams = {};
        self.settingsError = {};

        if (editMode) {
            self.settingsParams = angular.copy(self.refund_invoice_no_settings);
        }

        self.invoiceNoEditMode = false;
        self.receiptNoEditMode = false;
        // self.refundReceiptNoEditMode = false; // Not in use
        self.refundInvoiceNoEditMode = editMode;
    }

    editPaymentDailyFreezingSlot(editMode){
        const self = this;

        self.settingsParams = {};
        self.settingsError = {};

        if (editMode) {

            self.settingsParams = angular.copy(self.payment_daily_freezing_slot_settings );
        }

        self.paymentDailyFreezingSlotEditMode = false;
        self.paymentDailyFreezingSlotEditMode = editMode;
    }

    editPaymentMonthlyFreezingSlot(editMode){
        const self = this;

        self.settingsParams = {};
        self.settingsError = {};

        if (editMode) {

            self.settingsParams = angular.copy(self.payment_monthly_freezing_slot_settings );
        }

        self.paymentMonthlyFreezingSlotEditMode = false;
        self.paymentMonthlyFreezingSlotEditMode = editMode;
    }

    editOtpNo(editMode){
        const self = this;

        self.settingsParams = {};
        self.settingsError = {};

        if (editMode) {

            self.settingsParams = angular.copy(self.otp_for_commercial_units_settings );
        }

        self.otpNoEditMode = editMode;
    }

    saveDeveloperSettings(_params, setting_name) {
        const self = this;

        self.settingsError = {};
        if (!self.isValidSettingsInput(_params, setting_name)){
            return;
        }

        _params.name = setting_name;

        if(setting_name === self.DEVELOPER_SETTINGS_PAYMENT_DAILY_FREEZING_SLOT){
            _params = self.calculateDurationFromEndTime(_params);
        }

        let url = 'sec/developer/settings';

        let params = angular.copy(_params);
        try{
            params.value = JSON.stringify(_params.value);
        }
        catch(ex){
            console.log();
        }

        let responseHandler = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Developer settings updated successfully.');

            self.otpNoEditMode = false;
            self.receiptNoEditMode = false;
            self.invoiceNoEditMode = false;
            self.refundReceiptNoEditMode = false; // Not in use
            self.refundInvoiceNoEditMode = false;
            self.paymentDailyFreezingSlotEditMode = false;
            self.paymentMonthlyFreezingSlotEditMode = false;

            self.getDeveloperSettings();
        };

        loading(true);
        if (params.id) {
            url += '/' + params.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    isValidSettingsInput(params, setting_name){
        const self = this;

        if(!params || !params.value){
            return false;
        }

        let isValid = true;

        if(setting_name === self.DEVELOPER_SETTINGS_DIFFERENT_OTP_FOR_COMMERCIAL_UNITS){
            if(params.value.prefix && params.value.prefix.length > 3){
                isValid = false;
                self.settingsError.prefix = "Only 3 maximum characters are allowed";
            }
            if(params.value.postfix && params.value.postfix.length > 3){
                isValid = false;
                self.settingsError.postfix = "Only 3 maximum characters are allowed";
            }
            if(params.value.starting_no && params.value.starting_no < 0){
                isValid = false;
                self.settingsError.starting_no = "Please enter starting number greater than zero";
            }
        }
        else if(setting_name === self.DEVELOPER_SETTINGS_PAYMENT_DAILY_FREEZING_SLOT)
        {

            if(!self.payment_daily_freezing_slot_settings.value.is_enable){
                isValid = true;
                return isValid;
            }

            let startDateTime = moment(params.value.start_time, 'HH:mm');
            let endDateTime = moment(params.value.end_time, 'HH:mm');

            startDateTime.month(8);
            startDateTime.date(31);

            endDateTime.month(8);
            endDateTime.date(31);

            startDateTime = startDateTime.utc();
            endDateTime = endDateTime.utc();

            if(!startDateTime.isValid()){
                isValid = false;
                self.settingsError["start_time_error"] = "Start time not valid.";
                return isValid;
            }

            if(!endDateTime.isValid()){
                isValid = false;
                self.settingsError["end_time_error"] = "End time not valid.";
                return isValid;
            }

            if(!startDateTime.isBefore(endDateTime)){
                isValid = false;
                self.settingsError["end_time_error"] = "End time should must be greater then Start time.";
                return isValid;
            }

            params.value["start_time"] = startDateTime.hour() + ":" + startDateTime.minute();
            params.value["end_time"] = endDateTime.hour() + ":" + endDateTime.minute();

        }
        else if(setting_name === self.DEVELOPER_SETTINGS_PAYMENT_MONTHLY_FREEZING_SLOT)
        {
            if(!self.payment_monthly_freezing_slot_settings.value.is_enable){

                params.value = {
                    "is_enable" : false,
                };

                isValid = true;
                return isValid;
            }

            if(self.payment_monthly_freezing_slot_settings.value.start_date){
                params.value["start_date"] = self.payment_monthly_freezing_slot_settings.value.start_date;
            }

            if(!params.value["start_date"]){
                isValid = false;
                self.settingsError["monthly_freeze_start_date_error"] = "Select start date.";
            }

            let startDateTime = moment(params.value.start_time, 'HH:mm');
            startDateTime.month(8);
            startDateTime.date(params.value.start_date);
            startDateTime = startDateTime.utc();

            if(!startDateTime.isValid()){
                isValid = false;
                self.settingsError["monthly_freeze_start_time_error"] = "Start time not valid.";
                return isValid;
            }

            params.value["is_enable"] = true;
            params.value["start_date"] = startDateTime.date();
            params.value["start_time"] = startDateTime.hour() + ":" + startDateTime.minute();
            let endDateTime = moment.utc("2019-08-31 23:59");
            params.value["end_date"] = endDateTime.date();
            params.value["end_time"] = endDateTime.hour() + ":" + endDateTime.minute();

        }
        else if (setting_name === self.DEVELOPER_SETTINGS_REFUND_PAYMENT_TRACKING_NUMBER){
            // WEB-2826 DMS : unable to set REFUND INVOICE NO. setting blank.
            // No validation needed
        }
        else{
            if(!params.value[setting_name + "_length"]){
                isValid = false;
                self.settingsError[setting_name + "_length"] = "Length field is required.";
            }
        }

        return isValid;
    }

    // ----------- EMAIL NOTIFICATIONS SECTION  ---------

    getEmailNotifications(){
        let self = this;

        let url = 'sec/developer/email-notifications';

        loading(true);
        self.SSHttpService.getAPIRequest(url,{limit:1000}).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.notifications = [];
            // WEB-4489: reset here too, so a refresh after the last prior rule is deleted empties the table
            self.prior_notifications = [];
            // WEB-4823: whether the developer has report R111, i.e. may add a report code 16 rule
            self.lawFirmSaleApplicationsAvailable = !!(response.data && response.data.law_firm_sale_applications_available);
            if(response.data.developer_email_notifications 
                && response.data.developer_email_notifications.length > 0){
                $.each(response.data.developer_email_notifications , function(index, notification){
                    if(notification.is_prior){
                        self.prior_notifications.push(notification);
                    }
                    else{
                        self.notifications.push(notification);
                    }
                });
            }
        });
    }

    /**
     * Open the add / edit notification modal (after a 2FA session check).
     *
     * @param {Object|null} notification The row to edit, or null to add.
     * @param {boolean} PRIOR_NOTIFICATIONS True for the "Prior Email Notifications" table.
     * @returns {void}
     *
     * @remarks WEB-4489: the form model is normalised to numbers (select models compare by
     *          identity, so a "3" from the API would show a blank select), is_enabled to 1/0, and
     *          the fortnightly start date to a Date for the `<input type="date">`.
     *          WEB-4823: the row's own report code is kept, so a report code 16 row stays editable
     *          (its type stays in the list) even when the developer no longer has report R111.
     */
    onUpdateNotification(notification, PRIOR_NOTIFICATIONS = false){
        const self = this;
        const S = self.ScheduleService;

        self.PRIOR_NOTIFICATIONS = PRIOR_NOTIFICATIONS;

        self.notificationParams = {};
        self.notificationErrors = {};
        self.notificationStartDate = null;
        let selected_properties = [];

        if(notification){
            self.notificationParams = angular.copy(notification);
            if(notification.property_ids){
                selected_properties = String(notification.property_ids).split(',').map(id => id.trim()).filter(id => id);
            }
        }

        self.notificationParams.report_code = S.toNumberOrNull(self.notificationParams.report_code);
        self.notificationParams.frequency = S.toNumberOrNull(self.notificationParams.frequency);
        self.notificationParams.schedule_day = S.toNumberOrNull(self.notificationParams.schedule_day);
        self.notificationParams.agency_id = S.toNumberOrNull(self.notificationParams.agency_id);
        self.notificationParams.law_firm_id = S.toNumberOrNull(self.notificationParams.law_firm_id);
        self.notificationOriginalReportCode = notification ? self.notificationParams.report_code : null;
        self.notificationParams.property_ids = selected_properties;
        // A row from before the column existed has no is_enabled: it is sent, so it is enabled
        self.notificationParams.is_enabled = (notification && (notification.is_enabled === false || notification.is_enabled === 0 || notification.is_enabled === '0')) ? 0 : 1;
        self.notificationStartDate = S.toDate(self.notificationParams.schedule_start_date);

        if (self.isAgencyCommissionNotification()) {
            self.loadCommissionAgencies();
        }
        if (self.isLawFirmSaleApplicationsNotification()) {
            self.loadSaleApplicationsLawFirms();
        }

        self.refreshPropertySelectize();

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            $('#updateDeveloperNotificationsModal').modal('show');
        });
    }

    /**
     * WEB-4489: whether the open form is an agency commission-claimable rule (report code 15).
     *
     * @returns {boolean}
     */
    isAgencyCommissionNotification(){
        const self = this;

        return !!self.notificationParams
            && self.notificationParams.report_code == self.EMAIL_NOTIFICATION_AGENCY_COMMISSION_CLAIMABLE;
    }

    /**
     * WEB-4823: whether the open form is a law firm sale applications rule (report code 16).
     *
     * @returns {boolean}
     */
    isLawFirmSaleApplicationsNotification(){
        const self = this;

        return !!self.notificationParams
            && self.notificationParams.report_code == self.EMAIL_NOTIFICATION_LAWFIRM_SALE_APPLICATIONS;
    }

    /**
     * WEB-4489: report types offered in the modal. Report code 15 has no "prior days" variant
     * (the server rejects is_prior for it), so it is left out of the prior table's modal.
     *
     * @returns {Array<{id: number, value: string}>}
     *
     * @remarks WEB-4823: report code 16 is never a prior rule either, and is offered only when the
     *          developer has report R111 (law_firm_sale_applications_available), or when the row being
     *          edited already is a code 16 rule. It stays in const_dict_notifications either way, so
     *          existing code 16 rows are always listed by name.
     */
    getNotificationTypeOptions(){
        const self = this;

        if (!self.PRIOR_NOTIFICATIONS) {
            let offerLawFirmRule = self.lawFirmSaleApplicationsAvailable
                || self.notificationOriginalReportCode == self.EMAIL_NOTIFICATION_LAWFIRM_SALE_APPLICATIONS;
            if (offerLawFirmRule) {
                return self.const_dict_notifications;
            }
            return self.const_dict_notifications.filter(x => x.id != self.EMAIL_NOTIFICATION_LAWFIRM_SALE_APPLICATIONS);
        }

        return self.const_dict_notifications.filter(x => x.id != self.EMAIL_NOTIFICATION_AGENCY_COMMISSION_CLAIMABLE
            && x.id != self.EMAIL_NOTIFICATION_LAWFIRM_SALE_APPLICATIONS);
    }

    /**
     * WEB-4489: frequencies for the selected type — fortnightly is report codes 15 and (WEB-4823) 16 only.
     *
     * @returns {Array<{id: number, value: string}>}
     */
    getNotificationFrequencyOptions(){
        const self = this;

        let options = self.ScheduleService.getFrequencyOptions(
            self.isAgencyCommissionNotification() || self.isLawFirmSaleApplicationsNotification()
        );
        // Same array instance between digests, so ng-options does not rebuild the select every time
        let key = options.map(x => x.id).join(',');
        if (self._frequencyOptionsKey !== key) {
            self._frequencyOptionsKey = key;
            self._frequencyOptions = options;
        }

        return self._frequencyOptions;
    }

    /**
     * WEB-4489: report type changed in the modal.
     *
     * @returns {void}
     *
     * @remarks Switching to report code 15 loads the agencies and defaults the frequency to
     *          monthly (the server's default for a new agency rule). Switching away drops the
     *          agency and a fortnightly frequency, which only report code 15 accepts.
     *          WEB-4823: switching to report code 16 loads the law firms and defaults the frequency to
     *          daily (the server's default for a new law firm rule). The agency / law firm of the type
     *          left behind is dropped; fortnightly is kept only between codes 15 and 16.
     */
    onNotificationTypeChange(){
        const self = this;

        self.notificationErrors = {};

        if (self.isAgencyCommissionNotification()) {
            if (!self.notificationParams.frequency) {
                self.notificationParams.frequency = self.FREQUENCY_MONTHLY;
            }
            self.notificationParams.law_firm_id = null;
            self.loadCommissionAgencies();
        } else if (self.isLawFirmSaleApplicationsNotification()) {
            if (!self.notificationParams.frequency) {
                self.notificationParams.frequency = self.FREQUENCY_DAILY;
            }
            self.notificationParams.agency_id = null;
            self.loadSaleApplicationsLawFirms();
        } else {
            self.notificationParams.agency_id = null;
            self.notificationParams.law_firm_id = null;
            if (self.notificationParams.frequency == self.FREQUENCY_FORTNIGHTLY) {
                self.notificationParams.frequency = null;
            }
        }

        self.refreshPropertySelectize();
    }

    /**
     * WEB-4489: frequency changed — the day picker is a weekday for weekly and a day of the month
     * for monthly, so a value picked for one is meaningless for the other.
     *
     * @returns {void}
     */
    onNotificationFrequencyChange(){
        const self = this;

        self.notificationParams.schedule_day = null;
        delete self.notificationErrors.schedule_day;
        delete self.notificationErrors.schedule_start_date;
    }

    /**
     * WEB-4489: agency changed — only that agency's projects can be selected.
     *
     * @returns {void}
     */
    onNotificationAgencyChange(){
        const self = this;

        delete self.notificationErrors.agency_id;
        self.refreshPropertySelectize();
    }

    /**
     * WEB-4823: law firm changed — only that law firm's projects can be selected.
     *
     * @returns {void}
     */
    onNotificationLawFirmChange(){
        const self = this;

        delete self.notificationErrors.law_firm_id;
        self.refreshPropertySelectize();
    }

    /**
     * WEB-4823: load, once per page, every law firm assigned to at least one of the developer's
     * projects, with the ids of those projects (GET sec/developer/law-firms/assigned).
     *
     * @returns {void} Fills self.saleApplicationsLawFirms ([{id, name, property_ids: [string]}],
     *                 in the server's order, which is by name).
     *
     * @remarks Runs only when report code 16 is used. A failed lookup is not fatal: the list is left
     *          unset (the next modal opening retries), the saved projects are kept and every project is
     *          offered — the server checks the law firm is assigned to them (412001 on property_ids).
     */
    loadSaleApplicationsLawFirms(){
        const self = this;

        if (self.saleApplicationsLawFirms || self.saleApplicationsLawFirmsLoading) {
            return;
        }

        self.saleApplicationsLawFirmsLoading = true;
        self.SSHttpService.getAPIRequest('sec/developer/law-firms/assigned').then(function (response) {
            self.saleApplicationsLawFirmsLoading = false;
            if (response instanceof Error || !response.data || !Array.isArray(response.data.law_firms)) {
                console.warn('WEB-4823: Unable to load the law firms assigned to the developer projects.', response);
                self.SSAlertService.warning('Law firms not loaded', 'Unable to load the law firms. Please try again.');
                self.refreshPropertySelectize();
                return;
            }

            self.saleApplicationsLawFirms = response.data.law_firms.map(lawFirm => ({
                id: Number(lawFirm.id),
                name: lawFirm.name,
                // strings, like the selectize values and self.properties lookups they are compared with
                property_ids: (lawFirm.property_ids || []).map(id => String(id)),
            }));
            self.refreshPropertySelectize();
        });
    }

    /**
     * WEB-4823: the law firm options for the modal. A rule's own law firm is kept even when it no
     * longer shows up in the lookup (e.g. unassigned from every project), so editing never blanks it.
     *
     * @returns {Array<{id: number, name: string}>}
     */
    getSaleApplicationsLawFirmOptions(){
        const self = this;

        let options = self.saleApplicationsLawFirms || [];
        let current = self.notificationParams && self.notificationParams.law_firm;
        if (current && current.id && !options.find(x => x.id == current.id)) {
            options = options.concat([{id: Number(current.id), name: current.name, property_ids: []}]);
        }
        // Same array instance between digests, so ng-options does not rebuild the select every time
        let key = options.map(x => x.id).join(',');
        if (self._lawFirmOptionsKey !== key) {
            self._lawFirmOptionsKey = key;
            self._lawFirmOptions = options;
        }

        return self._lawFirmOptions;
    }

    /**
     * WEB-4823: the projects a report code 16 rule may cover.
     *
     * @returns {Array} None until a law firm is picked; the firm's projects; or every project when the
     *                  firm is not in the lookup (so a saved selection is never dropped).
     */
    getSelectablePropertiesForLawFirm(){
        const self = this;

        if (!self.notificationParams.law_firm_id) {
            return [];
        }
        let lawFirm = (self.saleApplicationsLawFirms || []).find(x => x.id == self.notificationParams.law_firm_id);
        if (!lawFirm) {
            return self.properties || [];
        }

        return (self.properties || []).filter(property => lawFirm.property_ids.indexOf(String(property.id)) >= 0);
    }

    /**
     * WEB-4823: the "Agency / Law Firm" column of the list.
     *
     * @param {Object} notification A developer_email_notifications row.
     * @returns {string} The law firm of a report code 16 rule, the agency of any other rule, or '--'.
     */
    getNotificationScopeName(notification){
        const self = this;

        if (!notification) {
            return '--';
        }
        let scope = notification.report_code == self.EMAIL_NOTIFICATION_LAWFIRM_SALE_APPLICATIONS
            ? notification.law_firm
            : notification.agency;

        return scope && scope.name ? scope.name : '--';
    }

    /**
     * WEB-4489: load, once per page, every agency assigned to at least one of the developer's
     * projects, with the ids of those projects.
     *
     * @returns {void} Fills self.commissionAgencies ([{id, name, property_ids: [string]}], by name).
     *
     * @remarks WEB-4497: one call to GET sec/developer/email-notifications/agencies (3 queries on
     *          the server). If that fails — e.g. an API build without it answers 404 — it falls back
     *          to loadCommissionAgenciesPerProject(), so Web and API can be deployed in any order.
     *          Runs only when report code 15 is used.
     */
    loadCommissionAgencies(){
        const self = this;

        if (self.commissionAgencies || self.commissionAgenciesLoading) {
            return;
        }

        self.commissionAgenciesLoading = true;
        self.SSHttpService.getAPIRequest('sec/developer/email-notifications/agencies').then(function (response) {
            if (response instanceof Error || !response.data || !Array.isArray(response.data.agencies)) {
                console.warn('WEB-4497: developer-wide agency list unavailable, loading per project.', response);
                self.commissionAgenciesLoading = false;
                self.loadCommissionAgenciesPerProject();
                return;
            }

            self.commissionAgencies = response.data.agencies.map(agency => ({
                id: Number(agency.id),
                name: agency.name,
                // strings, like the selectize values and self.properties lookups they are compared with
                property_ids: (agency.property_ids || []).map(id => String(id)),
            }));
            self.commissionAgenciesLoading = false;
            self.refreshPropertySelectize();
        });
    }

    /**
     * WEB-4489 fallback for an API without GET sec/developer/email-notifications/agencies (WEB-4497):
     * GET sec/developer/agencies once per project, in parallel.
     *
     * @returns {void} Fills self.commissionAgencies like loadCommissionAgencies().
     *
     * @remarks GET sec/developer/agencies is per project and guarded by DMS_PROJ_VIEW_AGENCY on it;
     *          a project the user cannot view agencies for is skipped — the server would reject it
     *          for the rule anyway. ~10 s for ~115 projects on internal, hence WEB-4497.
     */
    loadCommissionAgenciesPerProject(){
        const self = this;

        if (self.commissionAgencies || self.commissionAgenciesLoading) {
            return;
        }
        if (!self.properties) {
            // Projects are still loading (getDeveloperProperties); retry shortly
            self.$timeout(function () { self.loadCommissionAgenciesPerProject(); }, 300);
            return;
        }

        let agencies = {};
        let pending = self.properties.length;
        let done = function () {
            pending--;
            if (pending > 0) {
                return;
            }
            self.commissionAgencies = Object.keys(agencies).map(id => agencies[id])
                .sort((a, b) => String(a.name).localeCompare(String(b.name)));
            self.commissionAgenciesLoading = false;
            self.refreshPropertySelectize();
        };

        self.commissionAgenciesLoading = true;
        if (!pending) {
            pending = 1;
            done();
            return;
        }

        $.each(self.properties, function (index, property) {
            let params = {property_id: property.id, include: 'agencies'};
            self.SSHttpService.getAPIRequest('sec/developer/agencies/', params).then(function (response) {
                if (!(response instanceof Error) && response.data) {
                    let names = {};
                    $.each(response.data.agencies || [], function (i, agency) {
                        names[agency.id] = agency.name;
                    });
                    $.each(response.data.property_agencies || [], function (i, agencyProject) {
                        let agencyId = agencyProject.agency_id;
                        if (!agencies[agencyId]) {
                            let agency = agencyProject.agency || {};
                            agencies[agencyId] = {
                                id: Number(agencyId),
                                name: names[agencyId] || agency.name || ('Agency ' + agencyId),
                                property_ids: [],
                            };
                        }
                        agencies[agencyId].property_ids.push(String(property.id));
                    });
                }
                done();
            });
        });
    }

    /**
     * WEB-4489: the agency options for the modal. A rule's own agency is kept even when it no
     * longer shows up in the lookup (e.g. no access to its projects), so editing never blanks it.
     *
     * @returns {Array<{id: number, name: string}>}
     */
    getCommissionAgencyOptions(){
        const self = this;

        let options = self.commissionAgencies || [];
        let current = self.notificationParams && self.notificationParams.agency;
        if (current && current.id && !options.find(x => x.id == current.id)) {
            options = options.concat([{id: Number(current.id), name: current.name, property_ids: []}]);
        }
        let key = options.map(x => x.id).join(',');
        if (self._agencyOptionsKey !== key) {
            self._agencyOptionsKey = key;
            self._agencyOptions = options;
        }

        return self._agencyOptions;
    }

    /**
     * WEB-4489: the projects that may be selected for the open form.
     *
     * @returns {Array} self.properties, or for report code 15 only the selected agency's projects
     *                  (none until an agency is picked; all when the agency is not in the lookup).
     *                  WEB-4823: likewise the selected law firm's projects for report code 16.
     */
    getSelectablePropertiesForNotification(){
        const self = this;

        if (self.isLawFirmSaleApplicationsNotification()) {
            return self.getSelectablePropertiesForLawFirm();
        }
        if (!self.isAgencyCommissionNotification()) {
            return self.properties || [];
        }

        if (!self.notificationParams.agency_id) {
            return [];
        }
        let agency = (self.commissionAgencies || []).find(x => x.id == self.notificationParams.agency_id);
        if (!agency) {
            // Agency not in the lookup (no agency access on its projects): do not drop the saved
            // projects — offer every project and let the server check the agency is on them.
            return self.properties || [];
        }

        return (self.properties || []).filter(property => agency.property_ids.indexOf(String(property.id)) >= 0);
    }

    /**
     * (Re)build the Projects multi-select from getSelectablePropertiesForNotification(), keeping the
     * current selection where it is still allowed.
     *
     * @returns {void}
     *
     * @remarks WEB-4489: selectize keeps its own copy of the options, so a narrower list needs a
     *          destroy + init. The selection is mirrored into notificationParams.property_ids through
     *          onChange, which is what the save reads.
     */
    refreshPropertySelectize(){
        const self = this;

        try{
            var selectize = $("#selectize")[0].selectize;
            if(selectize){
                selectize.destroy();
            }
        }
        catch(ex){
            console.log(ex);
        }

        let options = self.getSelectablePropertiesForNotification();
        let selected = (self.notificationParams.property_ids || []).map(id => String(id));
        // While the agency (WEB-4823: or law firm) lookup is loading, keep the saved selection rather than dropping it
        let lookupPending = (self.isAgencyCommissionNotification() && !self.commissionAgencies)
            || (self.isLawFirmSaleApplicationsNotification() && !self.saleApplicationsLawFirms);
        if (!lookupPending) {
            selected = selected.filter(id => options.find(property => String(property.id) === id));
        }
        self.notificationParams.property_ids = selected;

        self.initSelectizejs(selected, options);
    }

    /**
     * Create or update the rule in the modal.
     *
     * @returns {void}
     *
     * @remarks WEB-4489: sends an explicit field list instead of the whole row copy, adds the
     *          agency / schedule / enabled fields, keeps the modal open on a failed save with the
     *          server's per-field messages (sub-code 412001) under the fields, and reloads the list
     *          afterwards (the save response has no `agency`, which the list shows).
     *          WEB-4823: a report code 16 rule also sends its law_firm_id (and never an agency_id).
     */
    saveDeveloperNotification(){
        const self = this;
        const S = self.ScheduleService;

        self.notificationErrors = {};
        if (!self.isValidNotificationsInput()){
            return;
        }

        let url = 'sec/developer/email-notifications'

        let source = self.notificationParams;
        let params = {
            report_code: source.report_code,
            emails: S.splitEmails(source.emails).join(','),
            property_ids: (source.property_ids || []).toString(),
            is_enabled: source.is_enabled ? 1 : 0,
        };

        if(self.PRIOR_NOTIFICATIONS){
            params.is_prior = 1;
            params.prior_days = source.prior_days;
            params.frequency = source.frequency;
        }
        else{
            params.is_prior = 0;
            angular.extend(params, S.buildSchedule(source, self.notificationStartDate));
            if (self.isAgencyCommissionNotification()) {
                params.agency_id = source.agency_id;
            }
            if (self.isLawFirmSaleApplicationsNotification()) {
                params.law_firm_id = source.law_firm_id;
            }
        }

        let responseHandler = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.notificationErrors = S.parseFieldErrors(response);
                if (response.sub_code == 412003) {
                    self.hideModals();
                    self.SSAlertService.danger('Error!', 'This notification no longer exists. The list has been refreshed.');
                    self.getEmailNotifications();
                    return;
                }
                if (Object.keys(self.notificationErrors).length) {
                    self.SSAlertService.warning('Not saved', 'Please correct the highlighted fields.');
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.hideModals();
            self.SSAlertService.success('Developer notifications updated successfully.');
            self.getEmailNotifications();
        };

        loading(true);
        if (source.id) {
            url += '/' + source.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    deleteNotification(notification) {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self._deleteNotification(notification);
        });
    }
        
    _deleteNotification(notification) {
        let self = this;

        if (!notification){
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            'Are you sure you want to delete this?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/email-notifications/' + notification.id + '/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if(response.code == 409 && response.message){
                            self.SSAlertService.danger("Error!", response.message);
                        }
                        else{
                            self.SSAlertService.parseAndDisplayError(response);
                        }
                        return;
                    }

                    self.SSAlertService.success('Notification deleted successfully.');

                    // Remove from local data
                    jQuery.each(self.notifications, function (i, o) {
                        if (o.id == notification.id) {
                            self.notifications.splice(i, 1);
                            return false;
                        }
                    });
                });
            }
        );
    }

    /**
     * Client-side checks before the save; messages go to self.notificationErrors.
     *
     * @returns {boolean}
     *
     * @remarks WEB-4489: report code 15 also needs an agency and valid recipients (≤ 50); a
     *          fortnightly rule needs a start date. The server repeats every check (412001).
     *          WEB-4823: report code 16 likewise needs a law firm and valid recipients.
     */
    isValidNotificationsInput(){
        const self = this;
        const S = self.ScheduleService;

        let isValid = true;
        let isAgencyRule = self.isAgencyCommissionNotification();
        let isLawFirmRule = self.isLawFirmSaleApplicationsNotification();

        if(!self.notificationParams.report_code){
            self.notificationErrors.report_code = "Please select a report";
            isValid = false;
        }
        if(isAgencyRule || isLawFirmRule){
            let emailError = S.validateEmails(self.notificationParams.emails);
            if(emailError){
                self.notificationErrors.emails = emailError;
                isValid = false;
            }
            if(isAgencyRule && !self.notificationParams.agency_id){
                self.notificationErrors.agency_id = "Please select an agency";
                isValid = false;
            }
            if(isLawFirmRule && !self.notificationParams.law_firm_id){
                self.notificationErrors.law_firm_id = "Please select a law firm";
                isValid = false;
            }
        }
        else if(!self.notificationParams.emails){
            self.notificationErrors.emails = "Please enter email addresses";
            isValid = false;
        }
        if(self.PRIOR_NOTIFICATIONS){
            if(!self.notificationParams.prior_days){
                self.notificationErrors.prior_days = "Please enter number of days";
                isValid = false;
            }
        }
        else{
            let scheduleErrors = S.validateSchedule(self.notificationParams, self.notificationStartDate, isAgencyRule || isLawFirmRule);
            if(Object.keys(scheduleErrors).length){
                angular.extend(self.notificationErrors, scheduleErrors);
                isValid = false;
            }
        }
        if(!self.notificationParams.property_ids || !self.notificationParams.property_ids.length){
            if (isAgencyRule && !self.notificationParams.agency_id) {
                self.notificationErrors.property_ids = "Please select an agency first, then at least one of its projects";
            } else if (isLawFirmRule && !self.notificationParams.law_firm_id) {
                self.notificationErrors.property_ids = "Please select a law firm first, then at least one of its projects";
            } else {
                self.notificationErrors.property_ids = "Please select at least one property";
            }
            isValid = false;
        }

        return isValid;
    }

    /**
     * WEB-4489: one-line schedule for the list ("Weekly on Tuesday", "Fortnightly from 05/10/2026"…).
     *
     * @param {Object} notification
     * @returns {string}
     */
    getNotificationSchedule(notification){
        return this.ScheduleService.describeSchedule(notification);
    }

    /**
     * WEB-4489: whether a rule is switched off. A row without the column (older API) counts as on.
     *
     * @param {Object} notification
     * @returns {boolean}
     */
    isNotificationDisabled(notification){
        return !!notification && (notification.is_enabled === false || notification.is_enabled === 0 || notification.is_enabled === '0');
    }

    getNameByCode(array, code){
        const self = this;

        let name = '--';

        if(!code || !array){
            return name;
        }

        try{
            let obj = array.find(x => x.id == code);
            if(obj){
                name = obj.value;
            }
        }
        catch(ex){
            console.log(ex);
        }

        return name;
    }

    // ---------  Commission Approval Settings Section  -------

    editCommissionSettings(editMode){
        const self = this;

        self.commissionSettingsParams = {};
        self.commissionSettingsErrors = {};
        let selected_users = [];

        if(editMode){
            if(self.commission_settings){
                self.commissionSettingsParams.id = self.commission_settings ? self.commission_settings.id : 0;
                self.commissionSettingsParams.user_ids = {};
                $.each(self.commission_approval_levels, function(index, approval_level){
                    self.commissionSettingsParams.user_ids[index] = approval_level.user_ids;
                });
            }

            if(self.commission_approval_levels && self.commission_approval_levels.length > 0){
                self.updateUsersSelectize();
            }
            else{
                self.initUsersSelectize(selected_users, 0);
            }
        }
        else{
            self.commission_approval_levels = angular.copy(self.commission_approval_levels_master);
        }

        self.commissionSettingsEditMode = editMode;
    }

    updateUsersSelectize(){
        const self = this;

        $.each(self.commission_approval_levels, function(index, approval_level){

            var selected_users = [];
            // Remove selected 'items' from previous records, if any
            try{
                var selectize = $("#users_selectize_" + index)[0].selectize;
                if(selectize){
                    selectize.destroy();
                }
            }
            catch(ex){
                console.log(ex);
            }

            if(approval_level.user_ids){
                self.commissionSettingsParams.user_ids = {};
                self.commissionSettingsParams.user_ids[index] = approval_level.user_ids;
                selected_users = (typeof approval_level.user_ids == 'string') ? approval_level.user_ids.split(',') : approval_level.user_ids;
            }

            self.initUsersSelectize(selected_users, index);
        });
    }

    addCommissionApprovalLevel(){
        const self = this;

        let index = self.commission_approval_levels.length;
        self.commission_approval_levels.push({level: index, user_ids: []});

        self.$timeout(function() {
            self.initUsersSelectize([], index);
        });
    }

    removeCommissionApprovalLevel(index){
        const self = this;

        self.commission_approval_levels.splice(index, 1);
        try{
            var selectize = $("#users_selectize_" + index)[0].selectize;
            if(selectize){
                selectize.destroy();
            }
        }
        catch(ex){
            console.log(ex);
        }

        let updated_levels = [];

        // Re-arrange previous objects to make sure levels are correct
        $.each(self.commission_approval_levels, function(i, level){
            updated_levels.push({level: i, user_ids: (typeof level.user_ids == 'string') ? level.user_ids.split(',') : level.user_ids});
        });

        self.commission_approval_levels = updated_levels;

        self.$timeout(function() {
            self.updateUsersSelectize();
        });
    }

    saveCommissionSettings(){
        const self = this;

        if(!self.isValidCommissionSettingInput()){
            return;
        }

        let url = 'sec/developer/settings';
        let params = self.getCommissionApprovalParams();

        let handleResponse = function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Commission approval settings updated successfully.');
            self.commissionSettingsEditMode = false;
            self.getDeveloperSettings();
        };

        loading(true);
        if (self.commissionSettingsParams.id) {
            url += '/' + self.commissionSettingsParams.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    getCommissionApprovalParams(){
        const self = this;

        let levels = [];

        $.each(self.commissionSettingsParams.user_ids, function(index, user_ids){
            if(user_ids.length > 0){
                levels.push({level: typeof index == 'string' ? parseInt(index) : index, user_ids: typeof user_ids == 'string' ? user_ids.split(',') : user_ids});
            }
        });

        let params = {
            name: 'commission_report_approval',
            value: JSON.stringify({
                levels: levels
            })
        };

        return params;
    }

    isValidCommissionSettingInput(){
        const self = this;

        self.commissionSettingsErrors = {};
        let isValid = true;

        // TODO: Implement custom validation or built-in validation
        // $.each(self.commission_approval_levels, function(index, level){
        //     if(!self.commissionSettingsParams.user_ids[index]){
        //         self.commissionSettingsErrors.user_ids[index] = "Please select user(s)";
        //         isValid = false;
        //     }
        // });

        return isValid;
    }

    getUserNames(commission_approval_level){
        const self = this;

        if(!(commission_approval_level && commission_approval_level.user_ids)){
            return '--';
        }

        let user_names = "";
        let user_ids = commission_approval_level.user_ids? (typeof commission_approval_level.user_ids == 'string' ? commission_approval_level.user_ids.split(',') : commission_approval_level.user_ids) : [];

        $.each(user_ids, function(index, user_id){
            let user = self.developer_users.find(x => x.id == user_id);
            if(user){
                // Don't append new-line/comma for last record
                user_names += (user.name ? user.name : user.display_name) + ((index < user_ids.length - 1) ? "\n" : "");
            }
        });

        return user_names;
    }

    // ---------- Session Timeout Settings -----------
    editSessionTimeoutSettings(editMode){
        const self = this;

        self.sessionTimeoutSettingsErrors = {};
        self.sessionTimeoutEditMode = editMode;
    }

    prepareSessionTimeoutResponse(){
        const self = this;
        let params = angular.copy(self.session_timeout);

        if(!self.session_timeout.value.enable)
        {
            params.value = {
                "name" : self.DEVELOPER_SETTINGS_SESSION_TIMEOUT,
                "enable" : false,
                "duration": 0
            };

            return params;
        }

        return params;
    }

    saveSessionTimeoutSettings(){
        const self = this;
        self.sessionTimeoutSettingsErrors = {};

        let url = 'sec/developer/settings';

        let params = self.prepareSessionTimeoutResponse();

        if(params.value.enable && params.value.duration <= 0){
            self.sessionTimeoutSettingsErrors.duration = "Value should be greater than 0";
            return;
        }

        try{
            params.value = JSON.stringify(params.value);
        }
        catch(ex){
            console.error(ex);
        }

        let handleResponse = function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Session timeout settings updated successfully.');
            self.sessionTimeoutEditMode = false;
            window.location.reload();
        };

        loading(true);
        if (params.id) {
            url += '/' + params.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    // ---------- Password Complexity Settings -----------
    editPasswordComplexitySettings(editMode){
        const self = this;

        self.passwordComplexitySettingsErrors = {};
        self.passwordComplexityEditMode = editMode;
    }

    savePasswordComplexitySettings(){
        const self = this;
        self.passwordComplexitySettingsErrors = {};

        let url = 'sec/developer/settings';

        let params = angular.copy(self.password_validation);

        if(params.value && !$.isEmptyObject(params.value)){
            if(params.value.min_length != null){
                if(params.value.min_length <= 0){
                    self.passwordComplexitySettingsErrors.minLength = "Value should be greater than 0";
                    return;
                }
                if(params.value.max_length != null && params.value.max_length < params.value.min_length){   
                    self.passwordComplexitySettingsErrors.maxLength = "Value should be greater than Minimum Length";
                    return;
                }
            }else{
                self.passwordComplexitySettingsErrors.minLength = "Minimum Length is required";
                return;
            }
        }

        try{
            params.value = JSON.stringify(params.value);
        }
        catch(ex){
            console.error(ex);
        }

        let handleResponse = function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Password Complexity settings updated successfully.');
            self.passwordComplexityEditMode = false;
            try{
                if(response.data.developer_settings && response.data.developer_settings.value){
                    self.password_validation = angular.copy(response.data.developer_settings);
                    if(typeof self.password_validation.value == "string"){
                        self.password_validation.value = JSON.parse(self.password_validation.value);
                    }
                    else{
                        self.password_validation.value = self.password_validation.value;
                    }
                }
            }
            catch(ex){
                console.log(ex);
            }
        };

        loading(true);
        if (params.id) {
            url += '/' + params.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            params.name = self.DEVELOPER_SETTINGS_PASSWORD_VALIDATION;
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    // ---------  Utility Methods  -------

    getDeveloperProperties(){
        let self = this;

        let url = 'sec/developer/properties/list';
        let params = {
            summary: true
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.properties = response.data.properties;
        });
    }

    prepareNotificationsDictionary(){
        const self = this;

        self.const_dict_notifications = [
            {
                id: self.EMAIL_NOTIFICATION_SPA_DELIVERY_EXPIRY,
                value: "Email Notification SPA Delivery Expiry",
            },
            {
                id: self.EMAIL_NOTIFICATION_SPA_EXPIRY,
                value: "Email Notification SPA Expiry",
            },
            {
                id: self.EMAIL_NOTIFICATION_OPTION_EXERCISED_SUMMARY,
                value: "Email Notification Option Exercised Summary",
            },
            {
                id: self.EMAIL_NOTIFICATION_OPTION_EXERCISED,
                value: "Email Notification Option Exercised",
            },
            {
                id: self.EMAIL_NOTIFICATION_OUTSTANDING_PROGRESSIVE_PAYMENTS,
                value: "Email Notification Outstanding Progressive Payments",
            },
            {
                id: self.EMAIL_NOTIFICATION_UPDATE_BUYER,
                value: "Email Notification Update Buyer",
            },
            {
                id: self.EMAIL_NOTIFICATION_UPDATE_BUYER_LAWYER,
                value: "Email Notification Update Buyer Lawyer",
            },
            {
                id: self.EMAIL_NOTIFICATION_NEW_PAYMENT_RECEIVED,
                value: "Email Notification New Payment Received",
            },
            // {
            //     id: self.EMAIL_NOTIFICATION_PAYMENT_CLAUSES,
            //     value: "Email Notification Payment Clauses",
            // },
            {
                id: self.EMAIL_NOTIFICATION_NEW_PROGRESSIVE_PAYMENTS,
                value: "Email Notification Progressive Payment Added",
            },
            {
                id: self.EMAIL_NOTIFICATION_NOTICE_SERVED_BY_LAWYER,
                value: "Email Notification Notice Served By Lawyer",
            },
            {
                id: self.EMAIL_NOTIFICATION_UNIT_RESERVED,
                value: "Email Notification Unit Reserved",
            },
            {
                id: self.EMAIL_NOTIFICATION_UNIT_RESERVED_OVERTIME,
                value: "Email Notification Unit Reserved Overtime",
            },
            {
                id: self.EMAIL_NOTIFICATION_PASSPORT_EXPIRY,
                value: "Email Notification Passport Expiry",
            },
            {
                // WEB-4489 (server WEB-4488): agency-scoped, never a "prior days" rule
                id: self.EMAIL_NOTIFICATION_AGENCY_COMMISSION_CLAIMABLE,
                value: "Email Notification Agency Commission Claimable",
            },
            {
                // WEB-4823: law-firm-scoped, never a "prior days" rule; offered only with report R111
                // (see getNotificationTypeOptions()), listed here so existing rows always show a name
                id: self.EMAIL_NOTIFICATION_LAWFIRM_SALE_APPLICATIONS,
                value: "Email Notification Lawfirm Sale Applications",
            }

        ];
    }

    prepareFrequencyDictionary(){
        const self = this;

        self.const_dict_frequencies = [
            {
                id: self.FREQUENCY_DAILY,
                value: "Daily",
            },
            {
                id: self.FREQUENCY_WEEKLY,
                value: "Weekly",
            },
            {
                id: self.FREQUENCY_MONTHLY,
                value: "Monthly",
            },
            {
                // WEB-4489: agency commission (and, WEB-4823, law firm sale applications) rules only;
                // listed here so existing rows show a name
                id: self.FREQUENCY_FORTNIGHTLY,
                value: "Fortnightly",
            }
        ];
    }

    /**
     * @param {Array<string>} selected_properties Selected project ids.
     * @param {Array} [options] Selectable projects; defaults to all of the developer's (WEB-4489).
     * @returns {void}
     */
    initSelectizejs(selected_properties, options) {
        const self = this;

        // selectize usage documentation: 
        // https://github.com/selectize/selectize.js/blob/master/docs/usage.md
        $('#selectize').selectize({
            valueField: 'id',
            labelField: 'name',
            sortDirection: 'desc',
            maxItems: null,
            options: options || self.properties,
            create: false,
            items: selected_properties,
            // WEB-4489: the save reads the selection from the form model
            onChange: function (value) {
                self.$timeout(function () {
                    self.notificationParams.property_ids = value ? [].concat(value) : [];
                    if (self.notificationErrors) {
                        delete self.notificationErrors.property_ids;
                    }
                });
            },
        });
    }

    initUsersSelectize(selected_users, index) {
        const self = this;

        // selectize usage documentation: 
        // https://github.com/selectize/selectize.js/blob/master/docs/usage.md
        $('#users_selectize_' + index).selectize({
            valueField: 'id',
            labelField: 'name',
            sortDirection: 'desc',
            maxItems: null,
            options: self.developer_users,
            create: false,
            items: selected_users,
        });
    }

    getSplittedValues(emails){
        const self = this;

        if(!emails){
            return '--';
        }

        try{
            emails = emails.trim().replaceAll(",", ",\n ");
        }
        catch(ex){
            console.log(ex);
        }

        return emails;
    }

    getPropertiesNames(property_ids){
        const self = this;

        let names = "";

        if(!property_ids || !self.properties){
            return names;
        }

        try{
            let ids = property_ids.split(',');

            $.each(ids, function(index, id){
                let property = self.properties.find(x => x.id == id);
                if(property){
                    names += property.name + ((index < ids.length - 1) ? "\n" : "");
                }
            });
        }
        catch(ex){
            console.log(ex);
        }

        return names ? names : '--';
    }

    hideModals(){
        const self = this;

        if ($('#updateDeveloperNotificationsModal').is(':visible')) $('#updateDeveloperNotificationsModal').modal('hide');
        if ($('#updateCommissionSettingsModal').is(':visible')) $('#updateCommissionSettingsModal').modal('hide');
    }


    addFatfBlacklistCountry() {
        const self = this;

        if (!self.selectedCountryForBlackList) { return false; }

        self.fatf_blacklist_countries = self.fatf_blacklist_countries || [];
        if (self.fatf_blacklist_countries.indexOf(self.selectedCountryForBlackList) < 0) {
            self.fatf_blacklist_countries.push(self.selectedCountryForBlackList);

            // Update non-blacklisted countries list
            self.non_blacklisted_countries = self.countries
                .filter(c => self.fatf_blacklist_countries.indexOf(c.country_code) === -1)
            self.$timeout(function () {
                $("select.eoi-select").niceSelect('update');
            });
        }
        self.selectedCountryForBlackList = "";
    }

    removeFatfBlacklistCountry(country_code){
        const self = this;

        self.fatf_blacklist_countries = self.fatf_blacklist_countries || [];
        if (country_code && self.fatf_blacklist_countries.indexOf(country_code) > -1) {
            self.fatf_blacklist_countries.splice(self.fatf_blacklist_countries.indexOf(country_code), 1);

            // Update non-blacklisted countries list
            self.non_blacklisted_countries = self.countries
                .filter(c => self.fatf_blacklist_countries.indexOf(c.country_code) === -1)
            self.$timeout(function () {
                $("select.eoi-select").niceSelect('update');
            });
        }
    }

    _saveFatfBlacklistCountriesSettings(){
        const self = this;

        let fatf_blacklist_countries = self.fatf_blacklist_countries ? self.fatf_blacklist_countries : [];

        let url = 'sec/developer/settings';
        let params = {
            name: "fatf_blacklist_countries",
            value: JSON.stringify(fatf_blacklist_countries)
        }

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.isEditFatfCountries = false;
            self.haveBlacklistCountries = false;
            self.SSAlertService.success('Success!', 'FATF Blacklist/Greylist Countries settings updated successfully.');
            self.getDeveloperSettings();
        };

        loading(true);
        if (self.fatf_blacklist_countries_settings && self.fatf_blacklist_countries_settings.id) {
            url += '/' + self.fatf_blacklist_countries_settings.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    getCountryDisplayName(country_code){
        self = this;

        let countryDisplayName = "";
        if(self.countries
                && self.countries.length
                && self.countries.find(c => c.country_code === country_code)){
            countryDisplayName = self.countries.find(c => c.country_code === country_code).name;
        }
        return countryDisplayName;
    }

    onEditFatfBlacklistCountriesSettings(){
        const self = this;

        if (self.fatf_blacklist_countries_settings && self.fatf_blacklist_countries_settings.value) {
            self.fatf_blacklist_countries = angular.copy(self.fatf_blacklist_countries_settings.value);
        }

        self.isEditFatfCountries = true;
    }

    onCancelFatfBlacklistCountriesSettings(){
        const self = this;

        self.fatf_blacklist_countries = [];
        if (self.fatf_blacklist_countries_settings && self.fatf_blacklist_countries_settings.value) {
            self.fatf_blacklist_countries = angular.copy(self.fatf_blacklist_countries_settings.value);
        }

        self.isEditFatfCountries = false;
    }

    onEnableDisableFatfBlacklist(){
        const self = this;

        if(self.haveBlacklistCountries){
            /*self.SSConfirmationService.getConfirmed(
                'Confirmation!',
                'Are you sure you want to proceed to disable FATF blacklist countries?<br/>The list will be removed.',
                self.SSConfirmationService.TYPE_OK,
                function () {
                    self.fatf_blacklist_countries = self.default_blacklist_countries;
                }
            );*/
        } else {
            /*self.SSConfirmationService.getConfirmed(
                'Confirmation!',
                'Are you sure you want to proceed to disable FATF blacklist countries?<br/>The list will be removed.',
                self.SSConfirmationService.TYPE_YES_NO,
                function () {
                    self.fatf_blacklist_countries = [];
                }
            );*/
        }
    }

    /** WEB-3055 DMS - Review New Sale - Disable action buttons till all documents are viewed - Start **/
    editSaleReviewSettings(){
        const self = this;

        self.sale_review_settings_bak = angular.copy(self.sale_review_settings);
        self.saleReviewSettingsEditMode = true;
    }

    cancelSaleReviewSettings(){
        const self = this;

        self.sale_review_settings = angular.copy(self.sale_review_settings_bak);
        self.sale_review_settings_bak = null;
        self.saleReviewSettingsEditMode = false;
    }

    saveSaleReviewSettings(){
        const self = this;

        let sale_review_settings = self.sale_review_settings ? self.sale_review_settings : {
            developer: {
                mandatory_documents_click: 0
            }
        };

        let url = 'sec/developer/settings';
        let params = {
            name: "sale_review_settings",
            value: JSON.stringify(sale_review_settings)
        }

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.saleReviewSettingsEditMode = false;
            self.SSAlertService.success('Success!', 'Sale Review setting updated successfully.');
            self.getDeveloperSettings();
        };

        loading(true);
        if (self.sale_review_settings_response && self.sale_review_settings_response.id) {
            url += '/' + self.sale_review_settings_response.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }
    /** WEB-3055 DMS - Review New Sale - Disable action buttons till all documents are viewed - End **/

    editPasswordBasedLogin() {
        const self = this;
        self.password_based_login_settings_bak = angular.copy(self.password_based_login_settings);
        self.passwordBasedLoginEditMode = true;
    }

    cancelPasswordBasedLogin() {
        const self = this;
        self.password_based_login_settings = angular.copy(self.password_based_login_settings_bak);
        self.password_based_login_settings_bak = null;
        self.passwordBasedLoginEditMode = false;
    }

    savePasswordBasedLogin() {
        const self = this;

        let url = 'sec/developer/settings';
        let params = {
            name: self.DEVELOPER_SETTINGS_PASSWORD_BASED_LOGIN,
            value: JSON.stringify(self.password_based_login_settings.value)
        }

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.passwordBasedLoginEditMode = false;
            self.SSAlertService.success('Success!', 'Password-based login setting updated successfully.');
            self.getDeveloperSettings();
        };

        loading(true);
        if (self.password_based_login_settings && self.password_based_login_settings.id) {
            url += '/' + self.password_based_login_settings.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }
}

DeveloperCustomSettingsController.$inject = [
    '$parse',
    '$timeout',
    'SSHttpService',
    'SSUtilService',
    'SSAlertService',
    'SSUserService',
    'OTPService',
    'SSConfirmationService',
    'SSConfigService',
    'SSEmailNotificationScheduleService'];
app.controller('DeveloperCustomSettingsController', DeveloperCustomSettingsController);

// WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js (services.js is
// loaded on every page). A copy here would link it a second time on every element.

// WEB-4411: the only `timepicker` registration in views/developer/settings/*.js.
app.directive("timepicker", function () {

    function link(scope, element, attrs) {
        // CALL THE "timepicker()" METHOD USING THE "element" OBJECT.
        element.timepicker();
    }

    return {
        require: 'ngModel',
        link: link
    };
});